import { render, staticRenderFns } from "./fileApproveLog.vue?vue&type=template&id=0badf295&scoped=true&"
import script from "./fileApproveLog.vue?vue&type=script&lang=js&"
export * from "./fileApproveLog.vue?vue&type=script&lang=js&"
import style0 from "./fileApproveLog.vue?vue&type=style&index=0&id=0badf295&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0badf295",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/98-prod-frontend-deploy-tke/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0badf295')) {
      api.createRecord('0badf295', component.options)
    } else {
      api.reload('0badf295', component.options)
    }
    module.hot.accept("./fileApproveLog.vue?vue&type=template&id=0badf295&scoped=true&", function () {
      api.rerender('0badf295', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/components/fileApproveLog.vue"
export default component.exports